export default "__VITE_ASSET__BYG66k8E__"